import React from 'react'

export const IconGridSizeDefault = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="4" y="2" width="4" height="20" rx="2" fill="currentColor" />
    <rect x="10" y="2" width="4" height="20" rx="2" fill="currentColor" />
    <rect x="16" y="2" width="4" height="20" rx="2" fill="currentColor" />
  </svg>
)
